<template>
  <sc-flex :is-column="true" v-if="!sent">
    <sc-flex :is-column="true">
      <sc-small>Your Email</sc-small>
      <v-text-field
        required
        placeholder="john.doe@example.com"
        solo
        v-model="email"
        class="default-input"
      />
    </sc-flex>
    <sc-flex :is-column="true">
      <sc-small>Your issue</sc-small>
      <v-textarea solo v-model="text" required class="default-input" />
    </sc-flex>
    <sc-button-group>
      <sc-button
        type="primary"
        :is-disabled="!isValid"
        @click="sendContactForm()"
        >Send</sc-button
      >
      <sc-button type="secondary" @click="$router.push(`/`)">Cancel</sc-button>
    </sc-button-group>
  </sc-flex>
  <sc-flex v-else :is-column="true" :gap="16">
    <sc-small
      >Thank you! Our team will respond to your request as soon as
      possible.</sc-small
    >
    <sc-button-group>
      <sc-button type="secondary" @click="$router.push(`/`)"
        >Back to Login</sc-button
      >
    </sc-button-group>
  </sc-flex>
</template>

<script>
import API from '@/api';

export default {
  name: 'ContactForm',
  props: {},
  computed: {
    isValid() {
      const isValid = this.email && this.text;

      return isValid;
    },
  },
  methods: {
    async sendContactForm() {
      try {
        const { email, text } = this;
        await API.help.sendContactForm({
          email,
          text,
        });

        this.sent = true;
      } catch (error) {
        console.error(error);
        this.$store.dispatch('application/setErrorNotification', {
          message:
            'Please try again a bit later. Our support team was notified.',
        });
      }
    },
  },
  data() {
    return {
      email: '',
      text: '',
      sent: false,
    };
  },
};
</script>
